import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MuiListItemIcon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemIcon';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { isBeforeTodayUTC } from 'Helpers/DateTime';

const styles = theme => ({
  root: {
    minWidth: 0,
    marginRight: theme.spacing(1),
  },
  cancelled: {
    color: theme.palette.facet.accentRed2,
  },
  complete: {
    color: theme.palette.facet.accentGreen,
  },
  selected: {
    color: theme.palette.common.white,
  },
});

const ListItemIcon = ({
  className,
  classes,
  resource,
  selected,
}) => {
  const getIcon = () => {
    const meetingIsCancelled = resource.attr('isCancelled') === 'true';
    const meetingHasOccurred = isBeforeTodayUTC(resource.attr('startTime'));
    const clientWasNoShow = resource.attr('clientNoShow') === 'true';
    const clientCancelled = resource.attr('clientCancelled') === 'true';

    let Icon;
    let iconClass;
    if (meetingIsCancelled || clientWasNoShow || clientCancelled) {
      Icon = CancelIcon;
      iconClass = selected ? 'selected' : 'cancelled';
    } else if (meetingHasOccurred && !meetingIsCancelled) {
      Icon = CheckCircleIcon;
      iconClass = selected ? 'selected' : 'complete';
    } else {
      Icon = RadioButtonUncheckedIcon;
      iconClass = selected && 'selected';
    }
    return <Icon className={classes[iconClass]} />;
  };

  return (
    <MuiListItemIcon
      className={classNames(classes.root, className)}
    >
      {getIcon()}
    </MuiListItemIcon>
  );
};

ListItemIcon.defaultProps = {
  className: '',
};

ListItemIcon.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ListItemIcon);
